import { TextField, TextFieldProps, InputAdornment, IconButton } from '@mui/material';
import Image from 'next/image';
import { FC } from 'react';
import { styles } from './style';

interface SimpleTextFieldProps extends Omit<TextFieldProps, 'error'> {
  error?: boolean;
  errorMessage?: string;
  status?: string;
  iconMethod?: () => void;
  height?: any;
  endIcon?: string;
  iconHeight?: number;
  iconWidth?: number;
}

export const MuiTextField3: FC<SimpleTextFieldProps> = ({
  error,
  errorMessage,
  status,
  iconMethod,
  height,
  endIcon,
  iconHeight = 18,
  iconWidth = 18,
  ...props
}) => {
  return (
    <TextField
      fullWidth
      variant='outlined'
      sx={styles(true).input}
      error={error}
      helperText={error ? errorMessage : ''}
      InputProps={{
        endAdornment:
          endIcon && iconMethod ? (
            <InputAdornment position='end'>
              <IconButton disableRipple onClick={iconMethod} edge='end'>
                <Image priority
                  src={endIcon}
                  alt='toggle visibility'
                  style={{ marginRight: '32px' }}
                  width={iconWidth}
                  height={iconHeight}
                />
              </IconButton>
            </InputAdornment>
          ) : null,
      }}
      {...props}
    />
  );
};

export default MuiTextField3;
